var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['number-control', _vm.type],attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.symbol)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }